import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

const isSurveyRoute = window.location.pathname.startsWith('/encuesta/');
const RootApplication = lazy(() => isSurveyRoute ? import('./PublicSurveyApp') : import('./App'));
const initialLoader = (
    <main style={{ minHeight: '100vh', display: 'grid', placeContent: 'center', textAlign: 'center', padding: '2rem' }}>
        <h2>Cargando</h2>
        <p>Espera unos segundos, por favor.</p>
    </main>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Suspense fallback={initialLoader}>
        <RootApplication />
    </Suspense>
);
reportWebVitals();
